import { useState } from "react";
import { router } from "@inertiajs/react";
import Tiptap from "@/components/TipTap/TipTap";
import PageHeader from "@/components/PageHeader";
import ConfirmDialog from "@/components/modals/ConfirmDialog";

export interface Brief {
  id: number;
  title: string;
  body: any;
  created_at: Date;
  user: {
    full_name: string;
    email: string;
  };
}

const Show: React.FC<{ brief: Brief }> = ({ brief }) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleting, setDeleting] = useState(false);

  const handleDelete = () => {
    setDeleting(true);
    router.delete(`/briefs/${brief.id}`, {
      onFinish: () => {
        setDeleting(false);
        setShowDeleteModal(false);
      },
    });
  };

  return (
    <div className="flex w-full flex-col items-start justify-start gap-5 md:gap-10">
      <PageHeader
        backLink={{ href: "/briefs", text: "Back to all briefs" }}
        title={brief.title}
        primaryAction={{ href: `/briefs/${brief.id}/edit`, text: "Edit" }}
        deleteAction={{
          onClick: () => setShowDeleteModal(true),
          text: "Delete",
        }}
      />
      <div className="flex w-full flex-col">
        <Tiptap content={brief.body} />
      </div>
      <ConfirmDialog
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleDelete}
        title="Delete brief"
        message="Are you sure you want to delete this brief? This action cannot be undone."
        confirmText="Delete"
        processing={deleting}
      />
    </div>
  );
};

export default Show;
